import moment from 'moment';

export const formatDate = (date) => moment(date?.substring(0, 10), 'YYYY-MM-DD').toDate();

export const leaveDateInFull = (rangeDate) => {
  moment.locale('pt-br');
  const startDate = moment(rangeDate?.[0]);
  const finalDate = moment(rangeDate?.[1]);

  const strStart = startDate.format('DD [de] MMMM [de] YYYY');
  const strEnd = finalDate.format('DD [de] MMMM [de] YYYY');

  if (!rangeDate) {
    return strStart;
  }

  return `${strStart} a ${strEnd}`;
};
